module.exports = __webpack_public_path__ + "static/media/logo-iso-white.67e05c1f.svg";